import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import GoogleMapReact from 'google-map-react';
//import { MarkerIcon } from '@components/icon/icon';
import Marker from './resultsmarker';

function MapsInfiniteHits(props) {
  let defaultLatLng = {
    lat: 53.472015,
    lng: -2.255918
  }
  if(props.defaultLatLng){
    defaultLatLng = props.defaultLatLng
  }
  const [mapenable, setMapenable] = useState(true);

  const [mapmarkers, setMapmarkers] = useState([]);

  const [center, setCenter] = React.useState(defaultLatLng);

  const ptype = props.ptype

  const mapUpdate = () => {
    setCenter(defaultLatLng);
  };
  

  useEffect(() => {
    var mapmarkersarr = [];
    const myObserverWhenMyNodeExist = () => {
      //if (typeof window === "undefined" || !window.document) 
      {
      var targetNode = document.getElementById('property_list_results');//document.getElementById('property_list_results');//$('#property_list_results')[0];//
      if(!targetNode) {
        //node not exist try again
        window.setTimeout(myObserverWhenMyNodeExist,500);
        return;
      }
      // Options for the observer (which mutations to observe)
      var config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      var callback = function(mutations, observer) {

        mapUpdate();
        mapmarkersarr.length = 0;
        // Use traditional 'for loops' for IE 11
        setMapmarkers([]);
        $('.mysingleproperty').each(function () {
          if (typeof $(this).data("lat") !== "undefined") {
            mapmarkersarr.push({objectid: "#"+ptype+$(this).data("objectid"), lat: $(this).data("lat"), lng: $(this).data("lng") })
          }
        });
        //console.log(mapmarkersarr)
        setMapmarkers(mapmarkers => mapmarkersarr);
        //setMapmarkers(mapmarkersarr);
        //console.log(mapmarkers)
        setMapenable(Math.floor(Math.random() * 100) + 1);
      };

      // Create an observer instance linked to the callback function
      var observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
      }
    }

    myObserverWhenMyNodeExist();
  }, [])
  // Return map bounds based on list of places
  const mygetMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds();

    places.forEach((place) => {
      bounds.extend(new maps.LatLng(
        place.lat,
        place.lng,
      ));
    });
    return bounds;
  };

  // Re-center map when resizing the window
  const mybindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
      maps.event.addDomListener(window, 'resize', () => {
        // map.fitBounds(bounds);
      });
    });
  };

  // Fit map to its bounds after the api is loaded
  const myapiHasLoaded = (map, maps, places) => {
    // Get bounds by our places
    const bounds = mygetMapBounds(map, maps, places);
    // Fit map to bounds
    // map.fitBounds(bounds);
    // Bind the resize listener
    mybindResizeListener(map, maps, bounds);
  };
  
  return (
    <div id="map" className="map">
    {mapenable &&
      <GoogleMapReact
          bootstrapURLKeys={{ 
            key: process.env.GATSBY_MAPS_API_KEY
          }}
          defaultCenter={defaultLatLng}
          center={center}
          water={false}
          zoom={10}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => myapiHasLoaded(map, maps, mapmarkers)}
      >
        {mapmarkers.map((pnt,ind) => 
          <Marker key={ind} lat={pnt.lat} lng={pnt.lng} text={pnt.objectid} />
        )}
      </GoogleMapReact>
    }
    </div>
  );
}

export default MapsInfiniteHits;